import React from 'react';
import style from './Header.module.css';
import cityPanoramaStyle from './CityPanorama.module.css';
import cityPanoramaImg from '../assets/images/city panorama.png';
import WaveHeaderSvg from "../assets/svg/WaveHeaderSvg";

function Header() {
    return (
        <div className={style.main}>
            <div className={cityPanoramaStyle.backgroundCityPanorama}>
                <img src={cityPanoramaImg} alt="" className={cityPanoramaStyle.cityPanoramaImg}/>
            </div>

            <div className={style.backgroundWave}>
                <WaveHeaderSvg className={style.waveSvg} />
            </div>

            <div className={style.bigScreen}>
                <div className={style.title}>
                    JEZIORKO CZERNIAKOWSKIE
                </div>

                <div className={style.subtext}>
                    Monitorujemy jakość wody i udostępniamy dane online,<br/> aby każdy mógł sprawdzić jej stan.
                </div>
            </div>

            <div className={style.smallScreen}>
                <div className={style.title}>
                    MONITORING <br/>
                    JEZIORKA CZERNIAKOWSKIEGO
                </div>
            </div>
        </div>
    );
}

export default Header;